/* ============================================================
   ENGRAM · assets/engram-help-portal.js — o início do centro de ajuda do CommSlayer (/apps/help)
   Por baixo das categorias do portal ficam as «Perguntas mais feitas» e o «Ainda com dúvidas» da página Ajuda
   (templates/page.ajuda.json): vão-se buscar a /pages/ajuda, na língua da loja, e põem-se a seguir ao portal.
   Assim o texto continua num só sítio (o editor do tema, na página Ajuda). Os estilos vêm com as secções; o
   assets/engram-help.js, que põe o cartão do contacto ao lado das perguntas no desktop, carrega-se depois.
   Só no início do portal (o que tem a pesquisa grande); nas categorias e nos artigos não se faz nada.
   Carregado por layout/theme.liquid (bloco ENGRAM do <head>) só em /apps/help.
   ============================================================ */
(function () {
  var SECTIONS = ['engram_help_faq', 'engram_help_contact'];

  function run() {
    var portal = document.querySelector('.commslayer-customer-portal');
    if (!portal || !portal.querySelector('.hero-section') || document.querySelector('.engram-help-portal-extras')) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'pages/ajuda', { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var page = new DOMParser().parseFromString(html, 'text/html');
        var extras = document.createElement('div');
        extras.className = 'engram-help-portal-extras';
        SECTIONS.forEach(function (key) {
          var section = page.querySelector('.shopify-section[id$="__' + key + '"]');
          if (section) extras.appendChild(document.importNode(section, true));
        });
        if (!extras.children.length) return;
        portal.insertAdjacentElement('afterend', extras);
        // os <script> que vêm no HTML não correm sozinhos: o que põe o cartão do contacto carrega-se aqui
        Array.prototype.forEach.call(extras.querySelectorAll('script[src]'), function (old) {
          var script = document.createElement('script');
          script.src = old.src;
          old.replaceWith(script);
        });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
